var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('Cell',{attrs:{"item":item,"order":_vm.order},on:{"updated":function($event){return _vm.$emit('updated')}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }